import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import PurchaseMenues from './Components/PurchaseRequest/MenuBar'
import PurchaseTable from './Components/PurchaseRequest/PurchaseTable'
import CreateRequestDialog from './Components/PurchaseRequest/CreatePrModal'
import { useState } from 'react'
import { useEffect } from 'react'
import { ApproveRequest, GetAllDevice, GetRequestList } from 'API/PurchaseRequest/api'
import BackdropLoader from './Components/General/Loader'
import SnackBar from './Components/General/SnackBar'
// import Autocomplete from '@mui/material/Autocomplete';
import { GetUserRole } from 'API/Misc/MakerChecker'
import { useLocation } from 'react-router'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const PurchaseRequest = () => {
    const [OpenCreateRequestDialog, setOpenCreateRequestDialog] = useState(false)
    const [DialogType, setDialogType] = useState("create")
    const [Devices, setDevices] = useState([])
    const [TableFilter, setTableFilter] = useState("pending")
    const [IsLoading, setIsLoading] = useState(false)
    const [TableData, setTableData] = useState(null)
    const [AlertMessage, setAlertMessage] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [UserRole, setUserRole] = useState(null)
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
    const [AlertOpen, setAlertOpen] = useState(false)
    const [Filter, setFilter] = useState({
        from_date: formattedDate,
        to_date: formattedDate,
        device: ""
    })



    const location = useLocation()

    // console.log("location",location)

    const [SelectedRow, setSelectedRow] = useState(null)

    const handleTableFilterChange = (filter) => {
        setTableFilter(filter)
    }
    const handleOpenCreateRequestDialog = (type, row) => {
        setOpenCreateRequestDialog(true)
        setDialogType(type)
        if (row) {
            setSelectedRow(row)
        }
    }

    const handleFilterChange = (field, value) => {
        console.log("value: ", value);

        setFilter({ ...Filter, [field]: value })
    }

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }

    const handleCloseAlert = () => {
        setAlertOpen(false)
    }

    const HandleGet = () => {
        GetRequestList(Filter, setIsLoading, TableFilter, setTableData, handleAlertOpen, 1, UserRole)
        GetAllDevice(setIsLoading, setDevices, handleAlertOpen)
    }

    useEffect(() => {
        if (UserRole) {
            HandleGet()
        }

    }, [TableFilter, UserRole])

    useEffect(() => {
        GetUserRole(location.pathname === "/procurement/create_purchase_order" ? "purchase_order" : "purchase_request", setIsLoading, setUserRole, handleAlertOpen)
    }, [])


    // console.log("user_role", UserRole);







    const handleProceed = (type, remarks) => {
        const data = { "request_id": SelectedRow._id, "status": type, remarks: remarks, ...UserRole }
        ApproveRequest(setIsLoading, data, handleAlertOpen, handleCloseCreateRequestDialog, HandleGet)
    }


    const handleSearch = () => {
        if (UserRole) {
            HandleGet()
        }
        else {
            handleAlertOpen("You are not authorized to view this page", "error")
        }
    }

    const handleClear = () => {
        setFilter({
            from_date: formattedDate,
            to_date: formattedDate,
            device: ""
        })

        GetRequestList({
            from_date: formattedDate,
            to_date: formattedDate,
            device: ""
        }, setIsLoading, TableFilter, setTableData, handleAlertOpen, 1, UserRole)

    }

    const handleNextPage = (page) => {
        GetRequestList(Filter, setIsLoading, TableFilter, setTableData, handleAlertOpen, page + 1, UserRole)

    }

    const handleCloseCreateRequestDialog = () => {
        setOpenCreateRequestDialog(false)
    }

    return (
        <Grid container>
            <BackdropLoader open={IsLoading} />
            <SnackBar open={AlertOpen} type={AlertType} message={AlertMessage} handleClose={handleCloseAlert} />
            <CreateRequestDialog UserRole={UserRole} filter={TableFilter} SelectedRow={SelectedRow} open={OpenCreateRequestDialog} handleClose={handleCloseCreateRequestDialog} type={DialogType} handleProceed={handleProceed} />
            <Grid item xs={12}>
                <MainCard>
                    <Grid container justifyContent="space-between" alignItems="center" gap={2}>
                        <Grid item md={6} xs={12}>
                            <Grid container spacing={1}>
                                <Grid item xl={6} lg={6} xs={12}>
                                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >From Date</Typography>
                                    <TextField
                                        id="outlined-basic"
                                        value={Filter.from_date}
                                        type='date'
                                        variant="outlined"
                                        size='small'
                                        onChange={(e) => handleFilterChange("from_date", e.target.value)}
                                        InputLabelProps={
                                            {
                                                shrink: true,
                                            }
                                        }
                                        inputProps={
                                            {
                                                max: formattedDate
                                            }
                                        }
                                        fullWidth
                                        onKeyDown={(e) => e.preventDefault()}
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                                borderRadius: '8px', // change border radius
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xl={6} lg={6} xs={12}>
                                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >To Date</Typography>
                                    <TextField
                                        id="outlined-basic"
                                        value={Filter.to_date}
                                        type='date'
                                        variant="outlined"
                                        onChange={(e) => handleFilterChange("to_date", e.target.value)}
                                        size='small'
                                        fullWidth
                                        inputProps={
                                            {
                                                max: formattedDate,
                                                min: Filter.from_date

                                            }
                                        }
                                        onKeyDown={(e) => e.preventDefault()}
                                        InputLabelProps={
                                            {
                                                shrink: true,
                                            }
                                        }
                                        sx={{
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                                borderRadius: '8px', // change border radius
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: '2px solid #A9A9A980 50%', // change border color
                                            },
                                        }}
                                    />

                                </Grid>
                                <Grid item xl={6} lg={6} xs={12} sx={{ display: 'none' }}>
                                    <FormControl fullWidth size='small'>
                                        <InputLabel id="demo-simple-select-label">Device</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={Filter.device}
                                            label="Device"
                                            onChange={(e) => handleFilterChange("device", e.target.value)}
                                        >
                                            {
                                                Devices && Devices.map((item, index) => (
                                                    <MenuItem value={item._id} key={index}>{item.bank_name}-{item.brand_name}-{item.name}</MenuItem>
                                                ))
                                            }

                                        </Select>
                                    </FormControl>
                                    {/* <Autocomplete
                                disablePortal
                                size='small'
                                onKeyDown={(e) => e.preventDefault()}
                                value={Filter.device && Filter.device !== "" ? Filter.device : null}
                                options={Devices ? Devices : []}
                                getOptionLabel={(option) => `${option.bank_name}-${option.brand_name}-${option.name}` || ""} // Adjust to match the key you want to display
                                onChange={(e, value) => handleFilterChange("device", value)}
                                fullWidth
                                renderInput={(params) => <TextField {...params} label="Device" />}
                            /> */}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={4} xs={12} mt={3}>
                        <Grid container spacing={1}>
                        <Grid item xl={4} lg={4} xs={12}>
                            <Button 
                                fullWidth 
                                variant='contained' 
                                color='secondary'  
                                onClick={() => handleSearch()}
                                sx={{
                    backgroundColor:"#688B2A",
                    color:"#fff",
                    borderRadius:"10px",
                    '&:hover': {
                      backgroundColor: "#688B3A",
                      color:"#fff",
                      borderRadius:"10px",
                    },
                    }}
                                >Search</Button>
                        </Grid>
                        <Grid item xl={4} lg={4} xs={12}>
                            <Button fullWidth variant='contained' color='secondary' sx={{borderRadius:"10px"}}  onClick={() => handleClear()}>Clear</Button>
                        </Grid>
                        <Grid item xl={4} lg={4} xs={12}>
                            {UserRole && UserRole.access_type === "maker" ? <Button fullWidth variant='contained' color='warning' sx={{borderRadius:"10px"}} onClick={() => handleOpenCreateRequestDialog("create")}>Create PR</Button> : null}
                        </Grid>
                        </Grid>
                        </Grid>
                        {/* <Grid container justifyContent="flex-end" gap={2}>
                            
                        </Grid> */}
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xs={12} mt={2}>
                <MainCard>
                    <Grid container>
                        <Grid item xs={12}>
                            <PurchaseMenues route={location.pathname === "/procurement/create_purchase_order" ? true : false} filter={TableFilter} handleChange={handleTableFilterChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <PurchaseTable route={location.pathname === "/procurement/create_purchase_order" ? true : false} userrole={UserRole} filter={TableFilter} data={TableData} handdleOpenDialog={handleOpenCreateRequestDialog} setSelectedRow={setSelectedRow} handleNext={handleNextPage} />
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
        </Grid>
    )
}

export default PurchaseRequest